"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemedClassNames = exports.consumeTheme = void 0;
var tslib_1 = require("tslib");
var h = require("./createElement").h;
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./polyfill");
require("./style").injectStyle("common/global.css", "[data-duim-0-106-4]{-webkit-tap-highlight-color:transparent}");
var ThemeContext = React.createContext(null);
function consumeTheme(renderProp) {
    return (h(ThemeContext.Consumer, null, function (themeConfig) {
        var classNames = createThemedClassNames(themeConfig);
        return renderProp(classNames);
    }));
}
exports.consumeTheme = consumeTheme;
function appendThemeClassNames(themeConfig, className) {
    if (!className || !themeConfig) {
        return className;
    }
    var currentClassList = className.split(/\s+/);
    var mergedClassList = currentClassList.concat.apply(currentClassList, currentClassList.map(function (name) { return themeConfig[name]; }).filter(function (name) { return name; }));
    return mergedClassList.join(' ');
}
function createThemedClassNames(themeConfig) {
    return (function () {
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classes[_i] = arguments[_i];
        }
        return appendThemeClassNames(themeConfig, classnames_1.default.apply(void 0, classes));
    });
}
exports.createThemedClassNames = createThemedClassNames;
exports.default = ThemeContext;
